import React from 'react';
import t from 'react-translate';
import { css } from '@emotion/react';

import { NvModal, ModalType } from 'shared/components/nv-modal';
import CloneMentorshipProgramModalContent from './clone-mentorship-program-modal-content';
import CloneMentorshipProgramModalFooter from './clone-mentorship-program-modal-footer';

const modalStyles = css`
  .bs4-modal-footer {
    justify-content: center;
  }
`;

type CloneMentorshipProgramModalProps = {
  show: boolean;
  onClose: (payload?: { didStartClone?: boolean }) => void;
};

const CloneMentorshipProgramModal = ({
  show,
  onClose,
}: CloneMentorshipProgramModalProps) => {
  if (!show) {
    return null;
  }

  return (
    <NvModal
      type={ModalType.FIXED}
      modalStyles={modalStyles}
      fullHeight={false}
      width={960}
      height={770}
      header={t.MENTORING_PROGRAMS.PROGRAM_HEADER_MENU.CLONE.MODAL_TITLE()}
      body={<CloneMentorshipProgramModalContent onClose={onClose} />}
      footer={<CloneMentorshipProgramModalFooter onClose={onClose} />}
      show={show}
      onClose={onClose}
    />
  );
};

export default CloneMentorshipProgramModal;
